export default (items) => {

	const getSize = (list) => {
		return list.length + list.reduce((count, item) => {
			return count + getSize(item.children);
		}, 0);
	}

	return !items ? 0 : getSize(items);
}